/**
 * Maps in-memory os-settings to API PUT bodies (partial field updates).
 */

import type { OsSettingsRequest } from "@/services/api/os-settings/types";

/** Dock pin/hide PUTs must not send admin-only flags unless explicitly updated. */
export function toOsSettingsSyncPayload(
  settings: OsSettingsRequest,
  options?: { includeOpenWindowsMaximized?: boolean },
): OsSettingsRequest {
  const payload: OsSettingsRequest = {
    pinnedAppIds: settings.pinnedAppIds,
    hiddenAppIds: settings.hiddenAppIds,
    reopenWindowsOnLaunch: settings.reopenWindowsOnLaunch,
  };
  if (options?.includeOpenWindowsMaximized) {
    payload.openWindowsMaximized = settings.openWindowsMaximized;
  }
  return payload;
}
